export default __webpack_public_path__ + "static/Xponential-08256a4e3daa215cd73b032f415d1e37.png";